<template>
	<v-container grid-list-lg>
		<v-layout row wrap>      
			<v-flex lg10 class="userInfo">
				<label class="blackLabel">Email Address</label>        
				<v-text-field label="Email Address" class="dropdown" v-model="globalModalParams.customerEmail" solo single-line></v-text-field>
			</v-flex>
          <v-flex lg2 class="userInfo">            
            <label class="blackLabel">&nbsp;</label>        
            <v-btn color="bgLightBlue" class="text-xs-right" @click.stop="fncSendQuote">Send</v-btn>
          </v-flex>
          <v-flex lg1 class="userInfo">            
            <p style="padding-top:14px;"><strong>OR</strong></p>
          </v-flex>
          <v-flex lg2 class="userInfo">            
            <v-btn color="bgLightBlue" class="text-xs-right" @click.stop="fncDownloadQuote">Download</v-btn>
          </v-flex>
			<div class="pl-4 pr-2 pb-4 buttonHolder">
				<div style="float: right">
					<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Close</v-btn>					
					<!--<v-btn color="success" class="text-xs-right" @click.stop="fncDownloadQuote">Download</v-btn>
					<v-btn color="success" class="text-xs-right" @click.stop="fncSendQuote">Send</v-btn>-->
				</div>
			</div>							
		</v-layout>
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex'; 	
	export default {
	  name: 'Settings',
	  data () {
			return {
              distributeEmail: this.globalModalParams.customerEmail
			};
		},		
		methods: {
			fncHideModal () {
				this.$store.commit('hideModal');
          },
          fncDownloadQuote() {
            this.$store.dispatch({
              type: 'fncQuoteAction',
              quoteId: this.globalModalParams.quoteId,
              email: null
            })
          },
          fncSendQuote() {
            this.$store.dispatch({
              type: 'fncQuoteAction',
              quoteId: this.globalModalParams.quoteId,
              email: globalModalParams.customerEmail
            })
          }
		},
		computed: {
			...mapGetters([
				'objAuthorize',					
				'globalModalParams',
			])
		}
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>